export default {
  number: "SchemaNumber",
  string: "SchemaString",
  select: "SchemaSelect",
  switch: "SchemaSwitch",
  radio: "SchemaRadio",
  checkbox: "SchemaCheckbox",
  color: "SchemaColor",
  upload: "SchemaUpload",
  jump: "SchemaJump",
  time: "SchemaTime",
  goods: "SchemaGoods",
  object: "SchemaObject",
  array: "SchemaArray",
  cube: "SchemaCapCube",
  course: "SchemaCourse",
  jumpData: "SchemaJumpData",
  prize: "SchemaPrize",
  popup: "SchemaPopup",
  editor: "SchemaEditor",
  form: "SchemaForm",
  formevent: "SchemaFormEvent",
  buttonConfig: "SchemaButtonConfig",
  radiusConfig: "SchemaRadiusConfig",
  timerLabelConfigure: "SchemaTimerLabelConfigure",
  anchor: "SchemaAnchor",
  baseUpload: "SchemaBaseUpload",
};
